/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import keyBy from 'lodash/fp/keyBy.js';
import { STRUCTURAL_RESPONSE_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';

const methods = [
  {
    id: STRUCTURAL_RESPONSE_METHOD_VALUES.SP3,
    name: 'SP3 Response Prediction Engine',
    abbreviation: 'SP3 SRPE',
  },
  {
    id: STRUCTURAL_RESPONSE_METHOD_VALUES.ASCE_7_22,
    name: 'ASCE 7-22 Design Demands',
    abbreviation: 'ASCE 7-22',
  },
  {
    id: STRUCTURAL_RESPONSE_METHOD_VALUES.RHA,
    name: 'User Defined Response History Analysis',
    abbreviation: 'RHA',
  },
  {
    id: STRUCTURAL_RESPONSE_METHOD_VALUES.MEDIANS,
    name: 'User Defined Medians',
    abbreviation: 'Median',
  },
];

export const methodById = keyBy('id', methods);

export default methods;
